import React, { useEffect, useRef, useState } from "react";

// Modules

// App
import { filesystem_root, subdomain } from "../../../config";
import { jsonParser } from "../../../utils/helpers";

// UI components

export default function Thumbnail(props) {
  const [isError, setError] = useState(false);

  const isLibrarySlide =
    props.slide.initial_presentation === props.presentation.id ? false : true;
  const rootThumb = isLibrarySlide
    ? `${filesystem_root}/${subdomain}/presentations/${props.slide.initial_presentation}/${props.slide.initial_presentation}/thumbnails/slide_${props.slide.id}_thumbnail.jpg`
    : `${filesystem_root}/${subdomain}/slides/${props.slide.id}/slide_${props.slide.id}_thumbnail.jpg`;
  const [thumbnail, setThumbnail] = useState(`${rootThumb}?t=${Date.now()}`);
  let interval = useRef(null);
  const [isActive, setActive] = useState(
    isLibrarySlide ? false : props.isActive
  );

  const [pollInterval, setPollInterval] = useState(15000); // default
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (props.isActive === true) {
      onItemClicked();
      setActive(true);
    } else {
      setActive(false);
      onItemNavigatedAway();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isActive]);

  // Adjust the poll interval on error/success
  useEffect(() => {
    if (isError) {
      setPollInterval(1000); // fast check on error
    } else {
      setPollInterval(15000); // slower check on success
    }
  }, [isError]);

  useEffect(() => {
    if (isActive && props.isSlide && props.slide) {
      const json = jsonParser(props.slide.slide_json);

      if (json?.reveal?.slideThumbnail?.field_media_image) {
        setThumbnail(json.reveal.slideThumbnail.field_media_image);
      } else {
        // Start polling
        const poll = () => {
          setError(false);
          setThumbnail(`${rootThumb}?t=${Date.now()}`);
          timeoutRef.current = setTimeout(poll, pollInterval); // recursive call
        };
        poll();
      }
    } else {
      clearTimeout(timeoutRef.current);
    }

    return () => clearTimeout(timeoutRef.current); // Cleanup
  }, [isActive, pollInterval, props.isSlide, props.slide]);

  const onItemClicked = () => {
    if (props.isSlide && props.slide) {
      const json = jsonParser(props.slide.slide_json);

      // has bespoke
      if (json?.reveal?.slideThumbnail?.field_media_image) {
        setThumbnail(json.reveal.slideThumbnail?.field_media_image);
      } else {
        setThumbnail(`${rootThumb}?t=${Date.now()}`);
      }
    }
  };

  const onItemNavigatedAway = () => {
    setTimeout(() => {
      if (props.isSlide && props.slide) {
        const json = jsonParser(props.slide.slide_json);

        // has bespoke
        if (json?.reveal?.slideThumbnail?.field_media_image) {
          setThumbnail(json.reveal.slideThumbnail?.field_media_image);
        } else {
          setThumbnail(`${rootThumb}?t=${Date.now()}`);
        }
      }
    }, 30000);
  };

  return (
    <>
      {isError ? (
        <div className="no-thumb" data-thumb={thumbnail} />
      ) : (
        <img
          src={thumbnail}
          alt=""
          onError={() => {
            setError(true);
            setThumbnail(`${rootThumb}?t=${Date.now()}`);
          }}
        />
      )}
    </>
  );
}
